import { LoadableAfterPaint } from '@confluence/loadable';

export { preloadSpaceDetail } from '../src/preloadSpaceDetail';
export { preloadPersonalSpaceDetail } from '../src/preloadPersonalSpaceDetail';
export { ConfluenceSpaceType } from '../src/space-target-select/SpaceTargetSelect';
export type { SpaceTargetOption } from '../src/space-target-select/SpaceTargetSelect';
export type { SpaceOption } from '../src/space-selector/space-select-modal/useSpacePicker';
export const SpaceTargetSelect = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-SpaceTargetSelect" */ '../src/space-target-select/SpaceTargetSelect'
			)
		).SpaceTargetSelect,
});
